import "custom-event-polyfill";
import React from "react";
import ReactSlider from "Shared/Slider/react-slider";
import styled from "styled-components";
import "./Slider.scss";
import SliderLabels from "./SliderLabels";
import withFrame, { WithFrameProps } from "src/providers/frame/withFrame";

const ReactSliderWrapper = styled(ReactSlider)`
    /* classname from ReactSlider */
    .handle {
        background: ${(props) => props.theme.palette.common.white};
        border: 2px solid ${(props) => props.theme.palette.primary.main};
        border-radius: 20px;
        height: 20px;
        top: 24px;
        width: 20px;
    }
`;

interface SliderProps {
    className: string;
    min: number;
    max: number;
    onChange: (value: number) => void;
    step: number;
    sliderValue: number;
    tickPrefix: string;
    ticks: number[];
    tickLabel: string;
    controlled?: boolean;
}

class Slider extends React.Component<SliderProps & WithFrameProps> {
    public render() {
        return (
            <div className="OSSlider__container" data-e2e="slider">
                <ReactSliderWrapper
                    iframe={this.props.iframe}
                    className="OSSlider__input"
                    max={this.props.max}
                    min={this.props.min}
                    onAfterChange={this.props.onChange}
                    step={this.props.step}
                    defaultValue={this.props.sliderValue}
                    {...(this.props.controlled && { value: this.props.sliderValue })}
                />
                <div className="OSSlider__ticksContainer">
                    <SliderLabels
                        label={this.props.tickLabel}
                        prefix={this.props.tickPrefix}
                        ticks={this.props.ticks}
                    />
                </div>
            </div>
        );
    }

    public componentDidMount() {
        /* This event prevents the sliders from being
            mis-sized and not functioning properly. */
        // @ts-ignore
        this.props.iframe.window.dispatchEvent(new CustomEvent("resize"));
    }
}

export default withFrame(Slider);
